    <div class="about-us-section">
      <!-- Hero Banner -->
      <div class="hero-banner">
        <div class="hero-overlay">
          <p class="hero-subtitle">About Us</p>
          <h1 class="hero-title"><span class="heading-theme">Our Story:</span> Crafted for the Roads of Maharashtra</h1>
        </div>
      </div>

      <!-- Content Section -->
      <div class="content-container">
        <div class="content-grid">

          <!-- Left Side - Features -->
          <div class="features-column">
            <!-- Feature 1 -->
            <div class="feature-card">
              <div class="feature-icon">
                <img
                src="assets/cars-1.png"
                alt="Shiv Sewa fleet car"
                style="width: 130px;"
              />
              </div>
              <div class="feature-text">
                <h3 class="feature-title">Dedicated</h3>
                <p class="feature-description">Fleet Capacity</p>
              </div>
            </div>

            <!-- Feature 2 -->
            <div class="feature-card">
              <div class="feature-icon">
                <img
                src="assets/cars-2.png"
                alt="Shiv Sewa cab" 
                style="width:100%"
              />
              </div>
              <div class="feature-text">
                <h3 class="feature-title">Mumbai-</h3>
                <p class="feature-description">Trained Drivers</p>
              </div>
            </div>
          </div>

          <!-- Center - Taxi Image with Location Pin -->
          <div class="center-column">
            <div class="taxi-wrapper">
              <img
                src="assets/about-us-car.avif"
                alt="Shiv Sewa Taxi"
                class="taxi-image"
              />
            </div>
          </div>

          <!-- Right Side - Mission Statement -->
          <div class="mission-column">
            <div class="mission-content">
              <p class="mission-intro">Born in Mumbai, our mission is simple:</p>
              <p class="mission-statement">
                to provide reliable, high-quality vehicle transfers and eliminate travel anxiety across our home state.
              </p>
              <button (click)="scrollingtoTop()" class="cta-button">Join Shiv Sewa</button>
            </div>
          </div>

        </div>
      </div>
    </div>
